import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-api-table',
    templateUrl: './api-table.component.html',
    styleUrls: ['./api-table.component.css']
})
export class ApiTableComponent {

    @Input()
    public title;

    @Input()
    public header;

    @Input()
    public header_list_translate;

    @Input()
    public data;

    constructor() {
    }

    ngOnInit() {
    }

}
